<template>
    <div class="search-bar" >
        <span class="lt-Search sm-icon"></span>
        <input :class="{ 'disabled': hasAttemptedAction && cards.length >= 4 }" type="text" name="card-search" id="card-search" 
               @keyup="searchCards()" 
               placeholder="Search by issuer or card name" 
               :disabled="hasAttemptedAction && cards.length >= 4"></input>
        <p class="error-message" v-if="hasAttemptedAction && cards.length >= 4">Maxed out! Remove a card to compare a new one.</p>
        <div class="results-container" v-if="searchResults && !(hasAttemptedAction && cards.length >= 4)">
            <datalist class="search-results">
            <div v-for="card in searchResults" class="search-result" 
                     @click="addToCards(card.cardId)"
                     :class="{ 'disabled': hasAttemptedAction && cards.length >= 4 }">
                <img :src="card.imageUrl" class="search-img" v-if="card.imageUrl">
                <img src="../../shared/images/sample_credit_card.png" class="search-img" v-else>
                <p class="search-name" v-html="card.name"></p>
            </div>
            </datalist>
        </div>
    </div>
</template>
<style src="../../shared/sass/saved-cards/search-bar.scss" lang="scss"></style>
<script>
import SearchService from "../../shared/services/search-service";
import CardService from "../../shared/services/card-service";
import SavedCompareCardsMixin from "../../shared/mixins/saved-compare-cards";

    export default {
        name: "search-bar",
        mixins: [SavedCompareCardsMixin],
        props: {
            cards: {
                type: Array,
                default: () => [],
                required: true
            },
            externalLimitReached: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {
                searchResults: [],
                hasAttemptedAction: false
            }
        },
        computed: {
            // Removed computed properties - using direct template conditions instead
        },
        watch: {
            cards: function(newCards, oldCards) {
                // Reset the attempted action flag when cards are removed
                if (newCards.length < oldCards.length) {
                    this.hasAttemptedAction = false;
                }
            },
            externalLimitReached: function(newVal) {
                // When external component (like CategoryLookup) hits limit, mark attempted action
                // Only disable when someone tried to add a 5th card (not when we have exactly 4)
                if (newVal) {
                    this.hasAttemptedAction = true;
                }
            }
        },
        methods: {
            searchCards: function() {
                // Don't search if limit is reached and user has attempted action
                if (this.hasAttemptedAction && this.cards.length >= 4) {
                    return;
                }
                
                const search = document.getElementById("card-search").value;
                if (search.length >= 2) {
                    SearchService.searchCards(siteId, search).then((res) => {
                        if (res) {
                            var cards = res.data;
                            // Filter out cards that are already in the cards array (already displayed on the page for comparison)
                            this.searchResults = cards.filter(card => !this.cards.some(c => c.cardId == card.cardId));
                        }
                    });
                }
                if (search.length == 0) {
                    this.searchResults = [];
                }
            },
            addToCards: function(cardId) {
                // Check if limit is reached BEFORE attempting action
                if (this.cards.length >= 4) {
                    // Mark that user has attempted an action
                    this.hasAttemptedAction = true;
                    // Emit event to parent to show popup notification
                    this.$emit('limit-reached');
                    return;
                }

                var commonMarketingParams = analyticsTracking.getLTCookieParams();
                var trackData = analyticsTracking.mapTrackingParams(commonMarketingParams);
                trackData.creditCard_data = {
                    card_id: cardId,
                    card_page: window.location.href
                };
                analyticsTracking.track("Comparison Search Bar Engaged", trackData);
                // Reset search
                var cardSearch = document.querySelector('#card-search');
                cardSearch.value = '';
                this.searchResults = [];

                CardService.getCard(siteId, cardId).then((res) => {
                    if (res && res.data) {
                        // Use mixin method for consistent card adding logic
                        this.addCardToCompare(res.data);
                    }
                    else {
                        console.log(`Could not find card ${cardId}`);
                    }
                });
            }
        },
    }
</script>
